import { IonContent } from '@ionic/react';
import { ReactElement, useCallback } from 'react';
import { Machine } from '../../../api/graphql/generated';
import { useHasFeature } from '../../../api/hooks/feature.hooks';
import '../machine.css';
import {
  ModalNavigation,
  useModalNavigationContext,
} from '../../modal/modal-navigation';
import { MachineConnectionTypeSelection } from '../machine-connection-type-selection';
import { RegisterMachineCloud } from './register-machine-cloud';
import { RegisterMachineDirectConnect } from './register-machine-direct-connect';

export interface RegisterMachineProps {
  teamId: string;
  machine?: Partial<Machine>;
  onComplete?: (machine: Machine) => void;
}

const RegisterMachine = (props: RegisterMachineProps): ReactElement => {
  return (
    <ModalNavigation>
      <RegisterMachineConnectionTypeSelection {...props} />
    </ModalNavigation>
  );
};

const RegisterMachineConnectionTypeSelection = (
  props: RegisterMachineProps
) => {
  const hasDirectConnect = useHasFeature<boolean>('beacon-direct-connect');

  const navigation = useModalNavigationContext();

  const onCloudClick = useCallback(() => {
    navigation.push(() => (
      <IonContent>
        <RegisterMachineCloud {...props} />
      </IonContent>
    ));
  }, [navigation, props]);

  const onDirectConnectClick = useCallback(() => {
    navigation.push(() => (
      <IonContent>
        <RegisterMachineDirectConnect {...props} />
      </IonContent>
    ));
  }, [navigation, props]);

  return hasDirectConnect ? (
    <MachineConnectionTypeSelection
      onCloudClick={onCloudClick}
      onDirectConnectClick={onDirectConnectClick}
    />
  ) : (
    <RegisterMachineCloud {...props} />
  );
};

export { RegisterMachine };
